export function parseToNumber(val: string): number {
  if (!val) {
    return 0;
  }
  const cleanedInput = val.replace(/[^\d.-]/g, '');
  const numberValue = Number(cleanedInput);
  return isNaN(numberValue) ? 0 : numberValue;
}
